__turbopack_context__.v({
  "content": "carousel-module-scss-module__B8v2Cq__content",
  "image": "carousel-module-scss-module__B8v2Cq__image",
  "link": "carousel-module-scss-module__B8v2Cq__link",
  "short": "carousel-module-scss-module__B8v2Cq__short",
  "slide": "carousel-module-scss-module__B8v2Cq__slide",
  "swiper": "carousel-module-scss-module__B8v2Cq__swiper",
  "tall": "carousel-module-scss-module__B8v2Cq__tall",
  "wrapper": "carousel-module-scss-module__B8v2Cq__wrapper",
});
